import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["target", "template"];
  static values = {
    wrapperSelector: {
      type: String,
      default: ".nested-form-wrapper",
    },
  };

  add(e) {
    e.preventDefault();
    const id = new Date().getTime().toString();

    const content = this.templateTarget.innerHTML.replaceAll(/NEW_RECORD/g, id);
    this.targetTarget.insertAdjacentHTML("beforeend", content);

    const elements = this.targetTarget.querySelectorAll(
      this.wrapperSelectorValue
    );
    const lastElement = elements[elements.length - 1];

    const event = new CustomEvent("rails-nested-form:add", {
      bubbles: true,
      detail: {
        id,
        insertedElement: lastElement,
      },
    });

    this.element.dispatchEvent(event);
  }

  remove(e) {
    e.preventDefault();

    const target = e.target;
    const wrapper = target.closest(this.wrapperSelectorValue);

    if (!wrapper) return;

    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove();
    } else {
      wrapper.style.display = "none";

      const input = wrapper.querySelector("input[name*='_destroy']");

      if (input) {
        input.value = "1";
      }
    }

    const event = new CustomEvent("rails-nested-form:remove", {
      bubbles: true,
      detail: {
        removedElement: wrapper,
        isNewRecord: wrapper.dataset.newRecord === "true",
      },
    });

    console.log("Dispatching event", event);
    this.element.dispatchEvent(event);
  }
}
